import app from 'flarum/forum/app';
import {override} from 'flarum/common/extend';
import DefaultResolver from 'flarum/common/resolvers/DefaultResolver';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import LightboxState from './states/LightboxState';
import Lightbox from './components/Lightbox';

export default function () {
    const lightbox = document.createElement('DIV');
    lightbox.id = 'cimaise-lightbox';
    document.body.insertBefore(lightbox, document.getElementById('alerts')!.nextSibling);

    app.cimaiseLightbox = new LightboxState();
    m.mount(lightbox, {
        view() {
            return m(Lightbox, {
                state: app.cimaiseLightbox,
            });
        },
    });

    override(DefaultResolver.prototype, 'onmatch', function (original: any, args: any, requestedPath: string, route: string) {
        // If the lightbox is inactive, let Flarum do its thing
        if (!app.cimaiseLightbox.isOpen()) {
            return original(args, requestedPath, route);
        }

        // If the lightbox is active and the user navigates to a different picture, change picture in the lightbox
        // TODO: if album is different, exit lightbox
        // TODO: allow customization of route names that open a picture for extensibility
        if (this.routeName === 'cimaisePictureShow') {
            app.cimaiseLightbox.openPage(args.id);

            // Never resolving promise
            return new Promise(() => {
            });
        }

        // If the target page is different, close lightbox and navigate
        app.cimaiseLightbox.close(false);

        return original(args, requestedPath, route);
    });

    override(DiscussionPage.prototype, 'positionChanged', function (original: any, startNumber: number, endNumber: number) {
        // If the lightbox is open, don't update the URL
        // In theory you can't scroll the discussion while the lightbox is open, however it still triggers if you resize the window
        if (app.cimaiseLightbox.isOpen()) {
            return;
        }

        return original(startNumber, endNumber);
    });

    document.addEventListener('keyup', function (event: KeyboardEvent) {
        // TODO: skip if inside of an input or something
        if (event.key === 'Escape' && app.cimaiseLightbox.isOpen()) {
            event.preventDefault();
            app.cimaiseLightbox.close();
        }
    });
}
